import axios from 'axios';

// CSRF Token
const _authenticityToken = document.getElementsByName('csrf-token')[0].content;
const _headers = {
  'X-CSRF-Token': _authenticityToken,
  'X-Requested-With': 'XMLHttpRequest',
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const registerRequest = (data) => {
  return axios({
    method: 'post',
    url: '/data-privacy',
    data,
  });
};
